import { render, staticRenderFns } from "./BehaviorsQuestion.vue?vue&type=template&id=c85c3c2e"
import script from "./BehaviorsQuestion.vue?vue&type=script&lang=js"
export * from "./BehaviorsQuestion.vue?vue&type=script&lang=js"
import style0 from "./BehaviorsQuestion.vue?vue&type=style&index=0&id=c85c3c2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports